// extracted by mini-css-extract-plugin
export default {"commentsCountButton":"RaTf4l"};